/* === SERENE HEAT — wishlist (localStorage) ===
 * Storage key: 'serene-wishlist'
 * Schema: [{ id: variantId, handle, title, image, price, url, addedAt }]
 *
 * Public API: window.SereneWishlist
 *   .add(item)   add or no-op if already saved
 *   .remove(id)  remove by variant id
 *   .toggle(item)
 *   .has(id)
 *   .all()
 *   .open() / .close()
 *   .clear()
 */
(function () {
  'use strict';

  var KEY = 'serene-wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    broadcast();
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function broadcast() {
    document.dispatchEvent(new CustomEvent('serene:wishlist:change', { detail: { items: read() } }));
  }

  function has(id) {
    if (id == null) return false;
    var items = read();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) return true;
    }
    return false;
  }

  function add(item) {
    if (!item || item.id == null) return;
    if (has(item.id)) return;
    var items = read();
    items.push(Object.assign({}, item, { addedAt: Date.now() }));
    write(items);
  }

  function remove(id) {
    var items = read().filter(function (x) { return String(x.id) !== String(id); });
    write(items);
  }

  function toggle(item) {
    if (!item || item.id == null) return false;
    if (has(item.id)) { remove(item.id); return false; }
    add(item); return true;
  }

  function clear() {
    write([]);
  }

  // === DOM: drawer ===
  var drawer, body, list, empty, foot, count, lastFocus;

  function refreshUI() {
    var items = read();
    if (count) {
      if (items.length > 0) { count.hidden = false; count.textContent = items.length; }
      else { count.hidden = true; count.textContent = '0'; }
    }
    if (!list) return;
    if (items.length === 0) {
      list.hidden = true;
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    list.hidden = false;
    var html = '';
    items.forEach(function (it) {
      html += '<li class="serene-drawer__item" data-wishlist-item data-id="' + escapeHtml(it.id) + '">'
        + '<a href="' + escapeHtml(it.url || '#') + '" class="serene-drawer__img">'
        + (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy" width="80" height="80">' : '')
        + '</a>'
        + '<div class="serene-drawer__info">'
        + '<a href="' + escapeHtml(it.url || '#') + '" class="serene-drawer__title">' + escapeHtml(it.title || '') + '</a>'
        + (it.variant_title ? '<div class="serene-drawer__opt">' + escapeHtml(it.variant_title) + '</div>' : '')
        + '<div class="serene-drawer__row">'
        + (it.price ? '<span class="serene-drawer__price">' + escapeHtml(it.price) + '</span>' : '<span></span>')
        + '<button type="button" class="serene-wishlist__add" data-wishlist-add data-id="' + escapeHtml(it.id) + '">Add to bag</button>'
        + '</div>'
        + '<button type="button" class="serene-drawer__remove" data-wishlist-remove data-id="' + escapeHtml(it.id) + '">Remove</button>'
        + '</div>'
        + '</li>';
    });
    list.innerHTML = html;
  }

  function setOpen(state) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
    drawer.classList.toggle('is-open', state);
    document.body.classList.toggle('serene-drawer-locked', state);
    if (state) {
      lastFocus = document.activeElement;
      var panel = drawer.querySelector('.serene-drawer__panel');
      if (panel) setTimeout(function () { panel.focus(); }, 30);
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  function open() { setOpen(true); }
  function close() { setOpen(false); }

  function bindDrawer() {
    drawer = document.querySelector('[data-serene-wishlist]');
    if (!drawer) return;
    body = drawer.querySelector('[data-serene-wishlist-body]');
    list = drawer.querySelector('[data-serene-wishlist-list]');
    empty = drawer.querySelector('[data-serene-wishlist-empty]');
    foot = drawer.querySelector('[data-serene-wishlist-foot]');

    drawer.querySelectorAll('[data-serene-wishlist-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var clearBtn = drawer.querySelector('[data-serene-wishlist-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      if (confirm('Clear your wishlist?')) clear();
    });

    drawer.addEventListener('click', function (e) {
      var rmBtn = e.target.closest('[data-wishlist-remove]');
      if (rmBtn) { remove(rmBtn.dataset.id); return; }
      var addBtn = e.target.closest('[data-wishlist-add]');
      if (addBtn) {
        var id = addBtn.dataset.id;
        if (!id) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = 'Added';
            // Refresh header/pill count from live cart state.
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('serene:cart:updated', { detail: cart }));
              })
              .catch(function () {});
            // Refresh cart drawer contents before opening so it isn't stale.
            if (window.SereneCart && typeof window.SereneCart.open === 'function') {
              var refresh = (window.SereneCart && typeof window.SereneCart.refresh === 'function')
                ? window.SereneCart.refresh()
                : Promise.resolve();
              refresh.then(function () {
                setTimeout(function () { close(); window.SereneCart.open(); }, 200);
              });
            } else {
              setTimeout(function () { addBtn.disabled = false; addBtn.textContent = 'Add to bag'; }, 1500);
            }
          })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Try again'; });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') { close(); return; }
      trapFocus(e);
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function getFocusable() {
    if (!drawer) return [];
    var panel = drawer.querySelector('.serene-drawer__panel');
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE))
      .filter(function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function bindTriggers() {
    document.querySelectorAll('[data-serene-wishlist-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    count = document.querySelector('[data-serene-wishlist-count]');
  }

  function bindHeartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-serene-wishlist-heart]');
      if (!btn) return;
      e.preventDefault();
      var item = {
        id: btn.dataset.id,
        handle: btn.dataset.handle || '',
        title: btn.dataset.title || '',
        image: btn.dataset.image || '',
        price: btn.dataset.price || '',
        url: btn.dataset.url || '',
        variant_title: btn.dataset.variantTitle || ''
      };
      var nowSaved = toggle(item);
      btn.classList.toggle('is-saved', nowSaved);
      btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      btn.setAttribute('aria-label', nowSaved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function syncHeartStates() {
    document.querySelectorAll('[data-serene-wishlist-heart]').forEach(function (btn) {
      var saved = has(btn.dataset.id);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  // === Init ===
  function init() {
    bindDrawer();
    bindTriggers();
    bindHeartButtons();
    syncHeartStates();
    refreshUI();
  }

  document.addEventListener('serene:wishlist:change', function () {
    refreshUI();
    syncHeartStates();
  });

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      refreshUI();
      syncHeartStates();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SereneWishlist = {
    add: add, remove: remove, toggle: toggle, has: has,
    all: read, clear: clear, open: open, close: close
  };
})();
